import { useMemo } from "react";
import useCompanyList from "~/features/SearchV3/hooks/useCompanyList";
import CompanyItem from "./CompanyItem";

const CompanyItemList = () => {
    const { filteredCompanies, selectedCompanyIds, checkItemSelection, handleCompanySelection } =
        useCompanyList();

    const companyList = useMemo(() => {
        return filteredCompanies?.map(item => (
            <CompanyItem
                key={item.id}
                companyId={item.companyId}
                isSelected={checkItemSelection(item.companyId)}
                btnClickCallback={handleCompanySelection}
            />
        ));
    }, [filteredCompanies, selectedCompanyIds]);

    return <div className="flex flex-col gap-1">{companyList}</div>;
};

export default CompanyItemList;
